import { render, staticRenderFns } from "./MasterEdit.vue?vue&type=template&id=4d984fcd"
import script from "./MasterEdit.vue?vue&type=script&lang=js"
export * from "./MasterEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports